import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './dataPointHistoryReport.template.html';
import { States } from "../../shared/config/constant.module";
import { StateParams } from "../../common";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { ICommonQueryingReport } from "./commonQueryingReport";
import navigation, { Plant } from "../../models/navigation";
import { DefectType } from "../../models/defectType";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import DataPointServiceName, { DataPointService } from "../../services/dataPoints/dataPoints.service";
import CountsServiceName, { CountsService } from "../../services/counts/counts.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import ShopServiceName, { ShopService } from "../../services/shops/shops.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import DefectTypeServiceName, { DefectTypeService } from "../../services/defects/defectType.service";
import { IStateService } from 'angular-ui-router';
import { ICountByDataPointId } from '../../models/counts/lineCounts';
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";

import IQService = angular.IQService;
import IPromise = angular.IPromise;
import { forEach } from '@uirouter/angularjs';

const requires = [UIUtilityServiceName, LoaderServiceName, CountsServiceName,
	ShopServiceName, NavigationServiceName, DefectTypeServiceName,
	DataPointServiceName];

interface IDataPointHistoryReportParams {
	userId: string;
	startDate: string;
	endDate: string;
	countInterval: apsEnums.CountInterval;
	dataPointIds: apsViewModels.DataPointDetail[];
	autoRun: boolean;
}

interface ISelectedRange {
	name: string;
	start(): moment.Moment;
	end(): moment.Moment;
}

//interface IDateRange {
//	name: string;
//	start: Function;
//	end: Function;
//}

//class DateRange {
//	name: string;
//	start: () => null;
//	end: function () : any {
//		return moment()
//	};
//}

class DataPointHistoryReortItem {
	dataPoint: apsViewModels.DataPointDetail;
	data: ICountByDataPointId[];
}

class DataPointHistoryReportCtrl {

	plants: Plant[];
	selectedPlant: Plant;
	selectedShop: apsViewModels.ShopNavigation;

	requirePlantSelection = true;
	requireShopSelection = true;

	startDate: Date;
	endDate: Date;
	uiStartDate: string;
	uiEndDate: string;

	countInterval: string = apsEnums.CountInterval.TenMinutes.toString();

	dataPoints: apsViewModels.DataPointDetail[];
	selectedDataPoint: apsViewModels.DataPointDetail;
	selectedDataPoints: apsViewModels.DataPointDetail[] = [];

	dates: Array<Date> = new Array<Date>()
	table = {};

	form: angular.IFormController;

	today: Date = moment().toDate();
	yesterday: Date = moment().subtract(1, 'days').toDate();
	selectedRange: ISelectedRange = null;

	options = {

		title: {
			text: ''
		},

		xAxis: {
			categories: [],
		},

		legend: {
			layout: 'vertical',
			align: 'right',
			verticalAlign: 'middle'
		},

		plotOptions: {
			series: {
				label: {
					connectorAllowed: false
				}
			}
		},

		series: [],

		responsive: {
			rules: [{
				condition: {
					maxWidth: 500
				},
				chartOptions: {
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom'
					}
				}
			}]
		},

		credits: {
			enabled: false
		}

	};

	$state: angular.ui.IStateService;
	$stateParams: IDataPointHistoryReportParams;
	$q: angular.IQService;

	countsService: CountsService;
	shopService: ShopService;
	dataPointService: DataPointService;
	navigationService: NavigationService;
	loaderService: LoaderService;
	notifyService: NotifyService;

	data: Array<DataPointHistoryReortItem>;

	ranges = {
		"1": [
			{
				name: "Last 10 Minutes",
				start: () => moment().subtract(10, 'minute'),
				end: () => moment()
			},
			{
				name: "Last 30 Minutes",
				start: () => moment().subtract(30, 'minute'),
				end: () => moment()
			},
			{
				name: "Last Hour",
				start: () => moment().subtract(1, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 2 Hours",
				start: () => moment().subtract(2, 'hour'),
				end: () => moment()
			}
		],
		"2": [
			{
				name: "Last Hour",
				start: () => moment().subtract(1, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 2 Hours",
				start: () => moment().subtract(2, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 4 Hours",
				start: () => moment().subtract(4, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 8 Hours",
				start: () => moment().subtract(8, 'hour'),
				end: () => moment()
			}
		],
		"3": [
			{
				name: "Last 4 Hour",
				start: () => moment().subtract(4, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 8 Hours",
				start: () => moment().subtract(8, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 24 Hours",
				start: () => moment().subtract(24, 'hour'),
				end: () => moment()
			},
			{
				name: "Last 40 Hours",
				start: () => moment().subtract(40, 'hour'),
				end: () => moment()
			}
		],
		"4": [
			{
				name: "Last 3 days",
				start: () => moment().subtract(3, 'day'),
				end: () => moment()
			},
			{
				name: "Last 7 days",
				start: () => moment().subtract(7, 'day'),
				end: () => moment()
			},
			{
				name: "Last 15 days",
				start: () => moment().subtract(15, 'day'),
				end: () => moment()
			}
		],
		"5": [
			{
				name: "Today",
				start: () => moment(),
				end: () => moment()
			},
			{
				name: "Yesterday",
				start: () => moment().subtract(2, 'day'),
				end: () => moment()
			},
			{
				name: "Last 7 Days",
				start: () => moment().subtract(7, 'day'),
				end: () => moment()
			},
			{
				name: "Last 15 Days",
				start: () => moment().subtract(15, 'day'),
				end: () => moment()
			},
			{
				name: "Last 30 Days",
				start: () => moment().subtract(30, 'day'),
				end: () => moment()
			},
			{
				name: "This Month",
				start: () => moment().subtract(1, 'month'),
				end: () => moment()
			},
			{
				name: "Last Month",
				start: () => moment().subtract(2, 'month'),
				end: () => moment().subtract(1, 'month')
			},
		]
	};

	constructor(
		$state: angular.ui.IStateService,
		$stateParams: IDataPointHistoryReportParams,
		$q: IQService,
		navigationService: NavigationService,
		shopService: ShopService,
		dataPointService: DataPointService,
		countsService: CountsService,
		loaderService: LoaderService,
		notifyService: NotifyService,
	) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$q = $q;

		this.navigationService = navigationService;
		this.shopService = shopService;
		this.dataPointService = dataPointService;
		this.countsService = countsService;
		this.loaderService = loaderService;
		this.notifyService = notifyService;

		const now = moment().add(1, 'hours').startOf('hour');
		this.endDate = now.toDate();
		this.startDate = now.clone().subtract(1, 'days').toDate();

		let promise = navigationService.getNavigation().then((nav) => {
			this.plants = nav.plants();
			this.selectedPlant = nav.selectedPlant;
			this.selectedShop = nav.selectedShop;
			// this.loadState($stateParams);
		}).then(() => {
			this.loadDataPoints(this.selectedPlant.id);
		});

		loaderService.loadingPromise(promise);
	}

	loadDataPoints(plantId) {
		return this.dataPointService.get(plantId).then((dataPoints) => {
			this.dataPoints = dataPoints;
		});
	}

	plantSelected($event) {
		try {
			this.loadDataPoints(this.selectedPlant.id).then(() => {
				console.log("plant selected.");
			});
		}
		finally {
			if ($event === null) return;
			$event.stopPropagation();
			$event.preventDefault();
		}
	}

	//loadState(params: IDataPointHistoryReportParams): angular.IPromise<void> {
	//	if (params.startDate) {
	//		const startDate = moment(params.startDate);
	//		if (startDate.isValid()) {
	//			this.startDate = startDate.toDate();
	//		}
	//	}

	//	if (params.endDate) {
	//		const endDate = moment(params.endDate);
	//		if (endDate.isValid()) {
	//			this.endDate = endDate.toDate();
	//		}
	//	}

	//	if (params.autoRun) {
	//		return this.runReport();
	//	}

	//	return this.$q.when();
	//}

	//saveState() {
	//	const params: IDataPointHistoryReportParams = {
	//		userId: this.$stateParams.userId,

	//		selectedDataPoints: this.selectedDataPoints,
	//		startDate: this.startDate ? this.startDate.toISOString() : undefined,
	//		endDate: this.endDate ? this.endDate.toISOString() : undefined,
	//		countInterval: this.countInterval,
	//		autoRun: true
	//	};

	//	this.$state.transitionTo(this.$state.current.name, params);
	//}

	addClicked($event) {
		try {

			if (this.selectedDataPoint === null) return;

			if (this.selectedDataPoints.indexOf(this.selectedDataPoint) === -1 && this.selectedDataPoints.length < 6) {
				this.selectedDataPoints.push(this.selectedDataPoint);
			} else if(this.selectedDataPoints.length === 6){
				this.notifyService.error('The Maximum limit is 6');
			}
			this.selectedDataPoint = null;
		}
		finally {
			$event.stopPropagation();
			$event.preventDefault();
		}
	}

	selectItem(dataPoint){
		this.selectedDataPoint = dataPoint;
	}

	removeClicked($event, removeDp) {
		try {
			if (removeDp === null) {
				return;
			}

			this.selectedDataPoints = this.selectedDataPoints.filter((dp) => {
				return dp !== removeDp;
			});
		}
		finally {
			$event.stopPropagation();
			$event.preventDefault();
		}
	}

	private runReport(): IPromise<any> {

		this.table = {};

		this.dates = [];

		this.data = [];

		this.options.xAxis = {
			categories: []
		};

		this.options.series = [];

		this.data = new Array<DataPointHistoryReortItem>();
		const promises = [];

		angular.forEach(this.selectedDataPoints, (dataPoint) => {

			let promise = this.countsService.getByDatapointId(
				dataPoint.id,
				this.startDate,
				this.endDate,
				this.countInterval)
				.then((response) => {
					let item = new DataPointHistoryReortItem();
					item.data = response;
					item.dataPoint = dataPoint;
					this.data.push(item);
				});
			promises.push(promise);
		});

		return this.$q.all(promises).then(() => {
			console.log("report completed.", this.data.length);

			const distinct = (value, index, self) => {
				return self.indexOf(value) === index;
			};

			const sortDate = (a: Date, b: Date) => {
				return b.valueOf() - a.valueOf();
			};

			const fmt = (x: Date) => moment(x).format("L LT");

			angular.forEach(this.data, (row) => {
				this.dates = _.union(this.dates, row.data.map((d) => {
					return d.intervalStart;
				}));
			});

			const cats: string[] = this.dates
				.filter(distinct)
				.sort(sortDate)
				.reverse()
				.map(fmt)
				.filter(distinct)
				;

			const xaxis = {
				categories: cats,
				// type: 'logarithmic',
				labels: {
					rotation: -45,
					style: {
						fontSize: '13px',
						fontFamily: 'Verdana, sans-serif'
					}
				}
			};

			this.options.xAxis = xaxis;

			this.options.series = [];

			// build table

			const table = {};

			angular.forEach(cats, (date) => {
				const row = {};
				table[date] = row;
			});

			angular.forEach(this.data, (dp) => {
				const points = dp.data.sort((a, b) => {
					return sortDate(a.intervalStart, b.intervalEnd);
				});
				angular.forEach(points, (v) => {
					table[fmt(v.intervalStart)][dp.dataPoint.name] = v.value;
				});
			});

			const value = (row, col) => {
				const v = table[row][col];
				return v;
			};

			const values = (col) => {
				const m = Object.keys(table).map((row) => {
					const v = value(row, col);
					return v;
				});
				return m;
			};

			const series = (dps) => {
				const m = dps.map((dp) => {
					const d = {
						name: dp.name,
						data: values(dp.name)
					};
					return d;
				});
				return m;
			};

			this.options.series = series(this.selectedDataPoints);

			this.table = table;
		});
	}

	tableKeys() {
		return Object.keys(this.table);
	}

	selectedRangeChanged($event) {
		if (angular.isDefined(this.selectedRange)) {
			let a = this.selectedRange;
			if (a === null) {
				this.uiStartDate = null;
				this.uiEndDate = null;
				this.startDate = null;
				this.endDate = null;
			} else {
				this.uiStartDate = a.start().format("L LT");
				this.uiEndDate = a.end().format("L LT");
				this.startDate = a.start().toDate();
				this.endDate = a.end().toDate();
			}
		}
	}

	getSelectedRanges() {
		if (this.countInterval === null) return [];
		const selectedRanges = this.ranges[this.countInterval.toString()];
		return selectedRanges;
	}

	submit($event) {

		try {
			if (this.form.$invalid) {
				return;
			}
			//this.saveState();

			const loadPromise = this.runReport();

			this.loaderService.loadingPromise(loadPromise);
		}
		finally {
			if ($event == null) return;
			$event.stopPropagation();
			$event.preventDefault();
		}
	}
}

export default angular.module('aps.controller.dataPointHistoryReport', requires)
	.config(function ($stateProvider: angular.ui.IStateProvider) {
		$stateProvider.state({
			name: States.COUNTS_DATA_POINT_HISTORY,
			url: '/admin/reports/dataPointHistoryReport?'
				+ 'startDate&'
				+ 'endDate&'
				+ 'orderBy&'
				+ 'autoRun&'
				+ 'reportPlantId&'
				+ 'reportShopId',
			params: {
				startDate: { dynamic: true },
				endDate: { dynamic: true },
				orderBy: { dynamic: true },
				autoRun: { dynamic: true },
				reportPlantId: { dynamic: true },
				reportShopId: { dynamic: true },
			},
			controller: 'DataPointHistoryReportCtrl as vm',
			template: template,
			data: {
				pageTitle: 'Data Point History',
				authorizeAPSIOAdmin: true
			}
		});
	})
	.controller('DataPointHistoryReportCtrl', DataPointHistoryReportCtrl)
	.name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/dataPointHistoryReport.controller.ts